import { ErrorModal } from '@modusign/design-system';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useMount } from 'react-use';

import GlobalLoadingSpinner from '@app/components/Loading/GlobalLoadingSpinner';
import { convertDraftToPdf, getIsConvertingDraftToPdf } from '@app/features/form/state';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { Dispatch } from '@app/store/types';

import PreviewPage from '../PreviewPage';

interface DraftPreviewPageProps {
  draftId: string;
}

export default function DraftPreviewPage({ draftId }: DraftPreviewPageProps) {
  const dispatch = useDispatch<Dispatch>();
  const history = useHistory();

  const [previewPdfUrl, setPreviewPdfUrl] = useState<string | null>(null);

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const isLoading = useSelector(getIsConvertingDraftToPdf);

  const workspaceId = useWorkspaceId();
  useMount(async () => {
    const result = await dispatch(convertDraftToPdf({ workspaceId, draftId }));

    if (convertDraftToPdf.fulfilled.match(result)) {
      setPreviewPdfUrl(URL.createObjectURL(result.payload));
    } else if (convertDraftToPdf.rejected.match(result)) {
      setErrorMessage(result.error.message || '');
    }
  });

  if (isLoading) {
    return <GlobalLoadingSpinner />;
  }

  if (previewPdfUrl) {
    return (
      <PreviewPage
        src={previewPdfUrl}
        title="서식 미리보기"
        onExit={() => {
          URL.revokeObjectURL(previewPdfUrl);
          history.goBack();
        }}
      />
    );
  }

  return (
    <ErrorModal
      closeButtonLabel="뒤로가기"
      error={errorMessage}
      isOpen
      title="서식 변환 실패"
      onClose={() => {
        history.push('/drafts');
      }}
    />
  );
}
